import React from 'react';
import CatalogSettings from 'pages/SettingsPage/General/CatalogSettings';
import { SectionWrapper } from 'pages/SettingsPage/General/GeneralSettings.styled';
import LanguageSettings from 'pages/SettingsPage/General/LanguageSettings';

const GeneralSettings = () => {
  return (
    <>
      <SectionWrapper>
        <LanguageSettings />
      </SectionWrapper>
      <SectionWrapper>
        <CatalogSettings />
      </SectionWrapper>
    </>
  );
};

export default GeneralSettings;
